/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar, IntScalar } from "graphql-jsx";

type Option = Readonly<{
  playlistId: string;
  typeTitle: string;
  value: string;
  languageCode: string;
  order: number;
}>;

export const CreatePlaylistTitleRelation = async (option: Option) => {
  const $playlistId = <Variable name="playlist_id" scalar={<IdScalar />} value={option.playlistId} />;
  const $typeTitle = <Variable name="type_title" scalar={<StringScalar isNullable={false} />} value={option.typeTitle} />;
  const $value = <Variable name="value" scalar={<StringScalar isNullable={false} />} value={option.value} />;
  const $languageCode = <Variable name="language_code" scalar={<IdScalar />} value={option.languageCode} />;
  const $order = <Variable name="exposure_order" scalar={<IntScalar />} value={option.order} />;
  const { query, variables } = render(
    <Mutation operationName="CREATE_PLAYLIST_TITLE_RELATION">
      <SelectionSet
        name="updatePlaylist"
        alias="createPlaylistTitleRelation"
        argument={{
          where: {
            playlist_id: $playlistId
          },
          data: {
            _onlySearch: true,
            playlist_title: {
              create: [
                {
                  type_title: $typeTitle,
                  language: { connect: { language_code: $languageCode } },
                  value: $value,
                  exposure_order: $order
                }
              ]
            }
          }
        }}
      >
        <Field name="playlist_id" alias="id" />
        <SelectionSet name="playlist_title">
          <Field name="id" alias="uuid" />
          <Field name="exposure_order" alias="order" />
        </SelectionSet>
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    createPlaylistTitleRelation: {
      id: string;
      playlist_title: {
        uuid: string;
        order: number;
      }[];
    };
  }>;

  return await clients.playlist.request<Data>(query, variables);
};
